module.exports = __webpack_public_path__ + "static/img/thirdparty-data.cdc7a831.svg";